import React, { useState, useEffect } from 'react';
import axios from 'axios';
import ItemInput from './ItemInput';


const Category = (props) => {


    const filterQuestions = (cq, i) => {
        
        if (cq.categoryID == props.category.categoryID) {
            return <ItemInput key={cq.questionID} question={cq} handleItemChange = { props.handleItemChange } />
        }
       
    }

    return (
        <div key={props.category.categoryID}>
            <h3 ref={props.titleRef} className={props.show ? "catTitleShow" : "catTitleHide"} onClick={(e) => props.handleHeadingClick(e, props.index)} key={props.category.categoryID}>
                &nbsp;{props.category.categoryText}
            </h3>
            <div ref={props.blockRef} className={props.show ? "questionBlock show" : "questionBlock hide"}>
                {props.category.categoryInfo != "" ? <div className="call-to-action"><p>{props.category.categoryInfo} {props.category.categoryInfo}</p></div> : <React.Fragment />}
                <div className="inputBlock">
                    {props.questions.map((cq, i) => filterQuestions(cq, i))}
                    <a href="#" className="link-top" onClick={props.backToTop}>[^ back to top]</a>
                </div>
 
            </div>
  
        </div>
    )
}


export default Category;